import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'loader-3', 'Loader3', [["path",{"d":"M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9"}],["path",{"d":"M17 12a5 5 0 1 0 -5 5"}]]);